/*!
 * froala_editor v4.0.8 (https://www.froala.com/wysiwyg-editor)
 * License https://froala.com/wysiwyg-editor/terms/
 * Copyright 2014-2021 Froala Labs
 */

! function (e, t) {
    "object" == typeof exports && "undefined" != typeof module ? t(require("froala-editor")) : "function" == typeof define && define.amd ? define(["froala-editor"], t) : t(e.FroalaEditor)
}(this, function (e) {
    "use strict";
    e = e && Object.prototype.hasOwnProperty.call(e, "default") ? e["default"] : e, Object.assign(e.DEFAULTS, {
        segmentSpacings: {
            0: "0em",
            0.4: "0.4em",
            0.6: "0.6em",
            Default: "0.8em",
            1.0: "1.0em",
            1.2: "1.2em",
        }
    }), e.PLUGINS.segmentSpacing = function (n) {
        var o = n.$;
        return {
            _init: function e() { },
            apply: function a(e) {
                n.selection.save(), n.html.wrap(!0, !0, !0, !0), n.selection.restore();
                var t = n.selection.blocks();
                t.length && o(t[0])
                    .parent()
                    .is("td") && n.format.applyStyle("margin-block-end", e.toString()), n.selection.save();
                for (var i = 0; i < t.length; i++) o(t[i])
                    .css("margin-block-end", e), "" === o(t[i])
                        .attr("style") && o(t[i])
                            .removeAttr("style");
                n.html.unwrap(), n.selection.restore()
            },
            refreshOnShow: function r(e, t) {
                var i = n.selection.blocks();
                if (i.length) {
                    var l = o(i[0]);
                    t.find(".fr-command")
                        .each(function () {
                            var e = o(this)
                                .data("param1"),
                                t = l.attr("style"),
                                i = 0 <= (t || "")
                                    .indexOf("margin-block-end: " + e + ";");
                            if (t) {
                                var n = t.substring(t.indexOf("margin-block-end")),
                                    a = n.substr(0, n.indexOf(";")),
                                    r = a && a.split(":")[1];
                                r && r.length || "Default" !== l.text() || (i = !0)
                            }
                            t && -1 !== t.indexOf("margin-block-end") || "" !== e || (i = !0), o(this)
                                .toggleClass("fr-active", i)
                                .attr("aria-selected", i)
                        })
                }
            }
        }
    }, e.RegisterCommand("segmentSpacing", {
        type: "dropdown",
        html: function () {
            var e = '<ul class="fr-dropdown-list" role="presentation">',
                // t = this.opts.segmentSpacings;
                t = {
                    "0": "0em",
                    "0.4": "0.4em",
                    "0.6": "0.6em",
                    "Default": "0.8em",
                    "1.0": "1.0em",
                    "1.2": "1.2em",
                };
            for (var i in t) Object.prototype.hasOwnProperty.call(t, i) && (e += '<li role="presentation"><a class="fr-command '
                .concat(i, '" tabIndex="-1" role="option" data-cmd="segmentSpacing" data-param1="')
                .concat(t[i], '" title="')
                .concat(this.language.translate(i), '">')
                .concat(this.language.translate(i), "</a></li>"));
            return e += "</ul>"
        },
        title: "段间距",
        callback: function (e, t) {
            this.segmentSpacing.apply(t)
        },
        refreshOnShow: function (e, t) {
            this.segmentSpacing.refreshOnShow(e, t)
        },
        plugin: "segmentSpacing"
    }), e.DefineIcon("segmentSpacing", {
        template: "newIcon",
        PATH: '<svg width="16" height="18" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"><path d="M384.3 335.2a32.8 32.8 0 1 0 46.4-46.5L291.4 149.4a32.8 32.8 0 0 0-46.4 0L105.6 288.7a32.9 32.9 0 0 0 46.5 46.5l83.3-83.3v520.2l-83.3-83.3a32.9 32.9 0 0 0-46.5 46.5L245 874.6a32.8 32.8 0 0 0 46.4 0l139.3-139.3a32.8 32.8 0 0 0-46.4-46.5L301.1 772V252zM533.9 205.5m51.9 0l290.3 0q51.9 0 51.9 51.9l0 5.67q0 51.9-51.9 51.9l-290.3 0q-51.9 0-51.9-51.9l0-5.67q0-51.9 51.9-51.9ZM533.9 709.1m51.9 0l290.3 0q51.9 0 51.9 51.9l0 5.67q0 51.9-51.9 51.9l-290.3 0q-51.9 0-51.9-51.9l0-5.67q0-51.9 51.9-51.9ZM533.9 457.3m51.9 0l290.3 0q51.9 0 51.9 51.9l0 5.67q0 51.9-51.9 51.9l-290.3 0q-51.9 0-51.9-51.9l0-5.67q0-51.9 51.9-51.9Z"></path></svg>',
    })
});